export const iconFontAwesomeWeatherSunPlantWilt = (
	<i className="fa-solid fa-sun-plant-wilt"></i>
);
